/**
 * Resolves a worker-relative API path (e.g. "/api/parish/logo/...") to a fully-qualified URL
 * using VITE_API_BASE as the worker origin. We store API-relative paths in the database
 * (not full URLs with the worker hostname) so the same data works across dev / preview /
 * production deployments without rewriting rows. Use this helper anywhere an API-relative
 * path lands in an <img src>, <a href>, or similar — fetch() calls go through apiGet
 * which already handles the prepend.
 */
export function resolveApiUrl(
  path: string | null | undefined,
): string | undefined {
  if (!path) return undefined;
  if (/^https?:\/\//i.test(path)) return path;
  const base = import.meta.env.VITE_API_BASE;
  // No base configured (local dev with the Vite proxy) — leave the
  // path relative so the dev server's /api proxy handles it.
  if (!base || !/^https?:\/\//i.test(base)) return path;
  // new URL(absolutePath, base) keeps base's origin and drops base's
  // path, which is exactly what we want here: VITE_API_BASE ends in
  // "/api" and logo_url starts with "/api/...", so anchoring to the
  // origin avoids a double "/api/api/" prefix.
  try {
    return new URL(path, base).toString();
  } catch {
    return path;
  }
}
